









import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class SearchPlaceholder extends Vue {
  activeIndex = 0;

  loading = true;

  @Prop({
    type: String,
    // eslint-disable-next-line global-require
    default: require('@/assets/blank-img.png')
  })
  placeholderImg!: string;

  @Prop({
    type: String,
    default: '暂无搜索结果\n请尝试搜索其他医生'
  })
  placeholderText!: string;
}
